import { t } from '@lingui/core/macro';
import { AppLinkOptions, Message } from '@luminovo/design-system';
import { ExternalLinkIcon } from 'lucide-react';
import type { JSX } from 'react';

/** Without `link`, for a user who may not edit the formula, the box reports the error with no way to resolve it. */
export const ErrorInFormulaBox = ({ link }: { link: AppLinkOptions | undefined }): JSX.Element => {
    return (
        <Message
            attention="high"
            variant="red"
            size="small"
            title={t`Error in formula`}
            action={link && { label: t`Resolve`, startIcon: <ExternalLinkIcon />, link }}
        />
    );
};
